import React, { useEffect } from "react";

export const Navigation = (props) => {
  useEffect(() => {
    const handleLinkClick = () => {
      const navbar = document.querySelector(".navbar-collapse");
      if (navbar.classList.contains("in")) {
        navbar.classList.remove("in");
        navbar.classList.add("collapse");
      }
    };

    // Fecha o menu ao clicar em qualquer link do menu
    const links = document.querySelectorAll(".navbar-collapse a");
    links.forEach((link) => link.addEventListener("click", handleLinkClick));

    return () => {
      links.forEach((link) => link.removeEventListener("click", handleLinkClick));
    };
  }, []);

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            Vasconcellos
          </a>
        </div>

        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul className="nav navbar-nav navbar-right">
            <li><a href="#header" className="page-scroll">Home</a></li>
            <li><a href="#about" className="page-scroll">Sobre</a></li>
            <li><a href="#services" className="page-scroll">Serviços</a></li>
            <li><a href="#portfolio" className="page-scroll">Galeria</a></li>
            <li><a href="#team" className="page-scroll">Time</a></li>
            <li><a href="#contact" className="page-scroll">Contato</a></li>
          </ul>
        </div>
      </div>
    </nav>
  );
};